
// import * as Sentry from "@sentry/browser";
// import { Integrations } from "@sentry/tracing";


import angular from 'angular';
import uiRouter from 'angular-ui-router';
import common from './common/common';
import components from './components/components';
import services from './services/services';
import appComponent from './app.component';
import api from './app.api';
import appConfig from './app.config';
import 'angulartics';
import 'angulartics/src/angulartics-baidu';
import 'angulartics-google-analytics';
import FastClick from 'fastclick';
import translate from 'angular-translate';
import localeZhCn from './i18n/angular-locale_zh-CN';
FastClick.attach(document.body);
import 'angular-sanitize';
import modal from 'angular-ui-bootstrap/src/modal';
import downlistModal from './common/downlist-modal/downlist-modal';
import Raven from 'raven-js';
// Sentry.init({
//    dsn: 'https://4e13139cfb154100a312b8d12834c0d6@sentry.yuanben.org/6',
//    integrations: [
//      new Integrations.BrowserTracing(),
//    ],
//    release:process.env.RELEASE,
//    environment: process.env.ENVIRONMENT,
//    tracesSampleRate: 1.0,
//  });
 Raven.config("https://4e13139cfb154100a312b8d12834c0d6@sentry.yuanben.org/6",{release:process.env.RELEASE,
 environment: process.env.ENVIRONMENT})
 .addPlugin(require("raven-js/plugins/angular"), angular)
 .install();
angular.module('app', [
    uiRouter,
    common,
    components,
    services,
    api,
    appConfig,
    "angulartics",
    "angulartics.baidu",
    "angulartics.google.analytics",
    translate,
    'ngSanitize',
    modal,
    downlistModal,
    "ngRaven"
])
    .config(($locationProvider) => {
        "ngInject";
        $locationProvider.html5Mode(true).hashPrefix('!');
    })

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider.state('app', {
            abstract: true,
            resolve: {
               appUser: (userLogin) => {
                  return userLogin.getUser().catch(err=>{
                     console.log("请求超时")
                  });
              }
            }
        });

        $urlRouterProvider.otherwise('/');
    })

    .config(($analyticsProvider) => {
        "ngInject";

        $analyticsProvider.withAutoBase(true);
    })
    .config(($translateProvider, $provide) => {
        "ngInject";
        $translateProvider.translations('zh-CN', require('./i18n/zh-CN'))
        $translateProvider.translations('en', require('./i18n/en'))
        $translateProvider.useSanitizeValueStrategy('escaped');
        let lang = window.localStorage.yuanben_lang || window.navigator.language;
        if(['cn','zh','zh-CN','zh-HK','zh-TW'].indexOf(lang)!=-1){
            lang='zh-CN';
            $provide.value("$locale", localeZhCn);
        }else{
            lang='en'
        };
        window.localStorage.yuanben_lang=lang;
        $translateProvider.preferredLanguage(lang);
    })
    .config(($httpProvider)=>{
        "ngInject";
        $httpProvider.defaults.headers.common.locale=window.localStorage.yuanben_lang
    })
    .component('app', appComponent);



// WEBPACK FOOTER //
// ./src/app/app.js